export const ApplicationNames = {
  HUB: 'Hub',
  LENS: 'Lens',
  PIXEL_RAD: 'Pixel Radiology',
  THERAPIES_SITES: 'Therapies Sites',
  THERAPIES_SPONSORS: 'Therapies Sponsors',
  TRIALS_APP: 'Trials App',
  DAVID: 'David',
};
